import { SPACE_50 } from '@alltrails/denali/tokens';
import PopupOffset from '../../types/PopupOffset';

export const alltrailsPoiTarget = {
  // This is defined in the Mapbox style JSON of our new base map style `featuresets` property
  featuresetId: 'alltrails-poi'
};

export const targetSize = 64;

export const popupOffset: PopupOffset = {
  bottom: [0, targetSize / -2 - SPACE_50],
  'bottom-left': [targetSize / -2, targetSize / -2 - SPACE_50],
  'bottom-right': [targetSize / 2, targetSize / -2 - SPACE_50],
  top: [0, targetSize / 2 + SPACE_50],
  'top-left': [targetSize / -2, targetSize / 2 + SPACE_50],
  'top-right': [targetSize / 2, targetSize / 2 + SPACE_50],
  left: [targetSize / 2 + SPACE_50, 0],
  right: [targetSize / -2 - SPACE_50, 0]
};
